/**
 * @desc Functionality based on Bootstrap tooltip
 * @source https://getbootstrap.com/docs/4.3/components/tooltips/
 */
$(function () {
	$('[data-toggle="tooltip"]').tooltip({
		template: `
			<div class="custom-tooltip" role="tooltip">
				<div class="arrow"></div><div class="tooltip-inner"></div>
			</div>
		`,
		offset: 'auto,5px',
		boundary: 'window'
	})
});
